import React from 'react';
import { useRecordContext } from 'react-admin';

import ChipField, { getChipColors } from '../../common/fields/ChipField';

const SERVICE_LABELS = {
    web:       'Web',
    core:      'Core',
    kern4good: 'Kern4Good',
    infra:     'Infra',
    design:    'Design',
    lab:       'Lab',
    other:     'Autre',
};

const SERVICE_COLORS = {
    web:       '#4CAF50',
    core:      '#2196F3',
    kern4good: '#00BCD4',
    infra:     '#FF9800',
    design:    '#E91E63',
    lab:       '#9C27B0',
    other:     '#607D8B',
};

const ServiceTypeField = ({ source='service_type', label='Service', ...props }) => {
    const record = useRecordContext();
    if (!record?.service_type) return null;

    const color = SERVICE_COLORS[record.service_type] || '#607D8B';
    const text = SERVICE_LABELS[record.service_type] || record.service_type;

    return (
        <ChipField
            label={text}
            size="small"
            sx={getChipColors(color)}
            source={source}
            record={{ [source]: text }}
        />
    );
};

export default ServiceTypeField;
